import React from "react";
import { createRoot } from "react-dom/client";
import "./tailwind.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GlobalErrorBoundary } from "./shared/components/GlobalErrorBoundary";
import { initGlobalErrorListeners } from "./shared/globalErrorReporting";

// Registrado antes do render para não perder erros durante o carregamento
// inicial do app (ex.: falha ao montar o React root).
initGlobalErrorListeners();

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);

reportWebVitals();
